import { makeStyles } from '@material-ui/core';
import { rem, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

const tabFontSize = {
  '@media (max-height: 768px)': {
    fontSize: rem(0.75),
  },
  '@media (max-height: 576px)': {
    fontSize: rem(0.625),
  },
};

export const styles = makeStyles(theme => ({
  background: {
    backgroundColor: themeColor.lightBackground,
  },
  instructionTypography: {
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: vh(2.35),
    fontWeight: 500,
    letterSpacing: 0.5,
    color: themeColor.defaultTextColor,
    fontStyle: 'normal',
    height: '3.12vh',
    marginTop: '1.9vh',
    marginBottom: '1.9vh',
  },
  accountSelectionContainer: {
    padding: 20,
  },
  tenderListHeader: {
    color: theme.palette.info.main,
    fontWeight: 500,
    lineHeight: 1.13,
    fontSize: vh(2.08),
    padding: `.75vh 0`,
  },
  tenderListContainer: {
    backgroundColor: themeColor.white,
    marginBottom: 10,
    flexGrow: 1,
  },
  okButton: {
    fontSize: rem(1),
    marginLeft: '.75vw',
    '@media (max-width: 800px)': {
      fontSize: rem(0.875),
      marginLeft: '.5vw',
    },
  },
  cancelButton: {
    fontSize: rem(1),
    marginLeft: '.75vw',
    ...tabFontSize,
    '@media (max-width: 1024px)': {
      width: '10vw',
    },
    '@media (max-width: 800px)': {
      fontSize: `${rem(0.55)} !important`,
    },
  },
}));
